<template>
    <v-btn
        v-if="hasTwoLanguages"
        v-bind="$attrs"
        @click="model = anotherLanguage?.code ?? model"
        :class="{ 'v-btn--slim': colorTheme == 'inverted' }"
    >
        <template #prepend>
            <v-sheet
                rounded="circle"
                width="20"
                height="20"
                class="d-flex align-center justify-center"
                :class="{ 'v-btn--icon-green': colorTheme == 'inverted' }"
            >
                <v-icon icon="mdi-flag" size="12" :color="colorTheme == 'inverted' ? 'white' : 'green'" />
            </v-sheet>
        </template>
        {{ anotherLanguage?.name }}
    </v-btn>

    <v-menu v-if="hasManyLanguages" location="center" attach>
        <template v-slot:activator="{ props }">
            <v-btn variant="text" v-bind="props">
                <template #prepend>
                    <v-sheet rounded="circle" width="20" height="20" class="d-flex align-center justify-center">
                        <v-icon icon="mdi-flag" size="12" />
                    </v-sheet>
                </template>
                {{ currentLanguage?.name }}
            </v-btn>
        </template>

        <v-list class="text-left">
            <v-list-item v-for="lang in supportedLanguages" :key="lang.code" :value="lang.code" @click="model = lang.code">
                <v-list-item-title :class="{ 'text-primary': lang.code === model }">{{ lang.name }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core';
import { computed } from 'vue';
import { MenuLanguageLink } from '../../composables';

interface Props {
    modelValue: string;
    supportedLanguages?: MenuLanguageLink[];
    colorTheme?: string;
}

const props = defineProps<Props>();
const model = useVModel(props, 'modelValue');
const currentLanguage = computed(() => props.supportedLanguages?.find(x => x.code === props.modelValue));
const hasManyLanguages = computed(() => (props.supportedLanguages?.length ?? 0) > 2);
const hasTwoLanguages = computed(() => (props.supportedLanguages?.length ?? 0) == 2);
const anotherLanguage = computed(() =>
    hasTwoLanguages && currentLanguage.value ? props.supportedLanguages?.find(x => x.code != props.modelValue) : currentLanguage?.value
);
</script>
